import { useMemo } from 'react'

import environment from 'environment'

import { handleHighlight, handleMultiSelect } from 'app-redux/active/actions/multiSelectors'
import { CardType } from 'types/deck'

import { getCardCMC } from 'utils/GetCardCMC'
import { calculateManaCurve } from 'utils/manaCurve'

import BarChart from 'components/deckPage/charts/BarChart'

import styles from './manaCurveV2.module.scss'

type Props = {
  cards: CardType[]
  showAverageManaValue?: boolean
  showTotalManaValue?: boolean
  barChartClassName?: string
  customLabel?: React.ReactNode
  hideEmptyCharts?: boolean
  dimEmptyCharts?: boolean
  className?: string
  relativeMaximum?: number
}

const ManaCurveV2 = ({
  cards,
  showAverageManaValue = false,
  showTotalManaValue = false,
  barChartClassName = '',
  customLabel = null,
  hideEmptyCharts = false,
  dimEmptyCharts = false,
  className = '',
  relativeMaximum,
}: Props) => {
  const { data, avgCmc, totalManaValue, isEmptyChart } = useMemo(() => calculateManaCurve(cards), [cards])

  const handleClickCmc = (e: React.MouseEvent, label: string) => {
    const controlKey = environment.getOnMac() ? e.metaKey : e.ctrlKey

    const selectedCards = cards.filter(card => {
      const cmc = getCardCMC(card)
      const selectedCmc = Number(label)

      if (Number.isNaN(selectedCmc) && cmc > 7) return true
      if (selectedCmc === cmc) return true

      return false
    })

    if (controlKey) return handleMultiSelect(selectedCards)

    handleHighlight(selectedCards)
  }

  if (isEmptyChart && hideEmptyCharts) return null

  return (
    <div
      className={`
        ${styles.container} ${className}
        ${isEmptyChart && dimEmptyCharts ? styles.emptyChart : ''}
      `}>
      {customLabel}
      {showAverageManaValue && (
        <label className={styles.avgCmc}>Avg Mana Value: {Number.parseFloat(`${avgCmc}`).toFixed(2)}</label>
      )}
      {showTotalManaValue && (
        <label className={styles.totalMv}>Total Mana Value: {Number.parseFloat(`${totalManaValue}`).toFixed(2)}</label>
      )}
      <BarChart
        data={data}
        onGlobalBarClick={handleClickCmc}
        className={barChartClassName}
        relativeMaximum={relativeMaximum}
      />
    </div>
  )
}

export default ManaCurveV2
